import * as React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GREEN_MAIN, GREEN_LOGO } from '../../../../theme/colors';

interface NationalEntityCheckboxProps {
    checked: boolean;
    handleChange: (value: string, key: string) => void;
}

const NationalEntityCheckbox: React.FC<NationalEntityCheckboxProps> = ({ checked, handleChange }) => {
    const { t } = useTranslation();

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    onChange={(event) => handleChange(event.target.checked ? 'true' : 'false', 'isNationalReference')}
                    sx={{
                        color: GREEN_MAIN,
                        '&.Mui-checked': {
                            color: GREEN_LOGO,
                        },
                    }}
                />
            }
            label={t('Entità Nazionale')}
            sx={{
                color: GREEN_MAIN,
                margin: 0,
                padding: '16px',
            }}
        />
    );
};

export default NationalEntityCheckbox;
